export default {
  code: {
    10001002: '未找到該資源',
    10001004: '缺少必要參數',
    10001005: '無權訪問該資源',
    20003002: '用戶名或密碼錯誤',
    20003003: 'loginCode已失效'
  },
  message: {
    serverError: '服务器发生错误，请稍后再试'
  }
}
